import { render, staticRenderFns } from "./video-call.vue?vue&type=template&id=58ea2269&scoped=true&"
import script from "./video-call.vue?vue&type=script&lang=ts&"
export * from "./video-call.vue?vue&type=script&lang=ts&"
import style0 from "./video-call.vue?vue&type=style&index=0&id=58ea2269&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ea2269",
  null
  
)

export default component.exports